import MagaluService, { isSuccess } from '@magalu/webzord';
export var useCart = function (logger) {
    if (logger === void 0) { logger = console; }
    return new Promise(function (resolve, reject) {
        try {
            MagaluService.request({
                serviceName: 'customer.basket.get.id',
                callbackId: 'get-cart',
                serviceArgs: {},
                callback: function (result) {
                    if (isSuccess(result)) {
                        var _a = result.body, basketId = _a.basket_id, oneClickBasketId = _a.one_click_basket_id;
                        resolve({ basketId: basketId, oneClickBasketId: oneClickBasketId });
                    }
                    else {
                        logger.error('[useCart] - error', result);
                        reject(null);
                    }
                },
            });
        }
        catch (error) {
            logger.error('[useCart] - error - catch', error);
            reject(error);
        }
    });
};
